export class TrailerOperation {
  constructor(
    public id?: number,
    public trailerPriority?: string,
    public broadCastTime?: number,
    public trailerPromo?: string,
    public trailerSnapshotFileName?: string,
  ) {}
}
export class TrailerOperationRequest {
  constructor(
    public id?: number,
    public trailerPriority?: string,
    public broadCastTime?: number,
    public trailerPromo?: string,
    public trailerSnapshotFileName?: string,
    public userId?: number,
    public username?: string,
  ) {}
}
